var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgX = function SvgX(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8909 26.75H6.10909C3.43945 26.75 1.25 24.5606 1.25 21.8909V6.10909C1.25 3.43945 3.43945 1.25 6.10909 1.25H21.8909C24.5606 1.25 26.75 3.43945 26.75 6.10909V21.8909C26.75 24.5606 24.5606 26.75 21.8909 26.75Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5139 12.7526L21.4194 5.89258H20.0194L14.8903 11.8489L10.7921 5.89258H6.07031L12.2558 14.9035L6.07031 22.0944H7.47031L12.8794 15.8071L17.2067 22.0944H21.9285L15.5139 12.7526ZM13.5921 14.9926L12.9685 14.0889L7.96668 6.94894H10.1176L14.1521 12.7144L14.7758 13.618L20.0067 21.1017H17.8558L13.5921 14.9926Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgX);
export default ForwardRef;